import React from 'react';
import { EntryForm } from './EntryForm';

export function EditEntry() {
  return <EntryForm mode="edit" />;
}